var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -3 82.9 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #20ac87;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #F39D40;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #024064;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "cls-3",
    d: "M12.3,12.4c0-1.5-1.2-2.2-3.3-2.2h-4.6v4.4h4.6c2.1,0,3.3-.7,3.3-2.2ZM4.4,3.8v4.2h4c2,0,3.1-.7,3.1-2.1s-1.1-2.1-3.1-2.1c0,0-4,0-4,0ZM15.2,12.7c0,2.6-2,4.1-6,4.1H1.6V1.6h7.1c3.7,0,5.6,1.5,5.6,4s-.8,2.7-2,3.4c1.6.5,2.7,1.8,2.7,3.8h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    className: "cls-3",
    d: "M29.8,10.2v6.7h-2.7v-6.3c0-2.1-1-3.1-2.8-3.1s-3.2,1.2-3.2,3.5v5.9h-2.7V.7h2.7v5.9c.9-1,2.3-1.5,3.9-1.5,2.8,0,4.9,1.6,4.9,5.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    className: "cls-3",
    d: "M40.7,13.2v-1.3h-2.8c-1.8,0-2.4.7-2.4,1.5s.8,1.6,2.2,1.6,2.5-.6,2.9-1.8h0ZM43.4,10v6.8h-2.6v-1.4c-.7,1-1.9,1.6-3.7,1.6-2.7,0-4.3-1.5-4.3-3.5s1.3-3.5,4.8-3.5h3v-.2c0-1.6-1-2.5-2.9-2.5s-2.7.4-3.5,1.2l-1.1-2c1.2-1,3-1.4,4.9-1.4,3.4,0,5.3,1.6,5.3,4.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    className: "cls-3",
    d: "M54.1,5.1v2.6h-.6c-2.1,0-3.4,1.2-3.4,3.6v5.6h-2.7V5.3h2.6v1.7c.8-1.2,2.2-1.8,4.1-1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    className: "cls-3",
    d: "M63.8,13.2v-1.3h-2.8c-1.8,0-2.4.7-2.4,1.5s.8,1.6,2.2,1.6,2.5-.6,2.9-1.8h0ZM66.5,10v6.8h-2.6v-1.4c-.7,1-1.9,1.6-3.7,1.6-2.7,0-4.3-1.5-4.3-3.5s1.3-3.5,4.8-3.5h3v-.2c0-1.6-1-2.5-2.9-2.5s-2.7.4-3.5,1.2l-1.1-2c1.2-1,3-1.4,4.9-1.4,3.4,0,5.3,1.6,5.3,4.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    className: "cls-3",
    d: "M77.4,16.2c-.7.5-1.6.8-2.6.8-2.5,0-4-1.3-4-3.9v-5.6h-1.9v-2.2h1.9v-2.7h2.7v2.7h3.1v2.2h-3.1v5.5c0,1.1.6,1.7,1.6,1.7s1.1-.2,1.5-.5l.8,1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    className: "cls-3",
    d: "M.5,28.9c0-4.5,3.5-7.8,8.2-7.8s4.6.9,6,2.5l-1.8,1.7c-1.1-1.2-2.5-1.8-4.1-1.8-3.2,0-5.4,2.2-5.4,5.4s2.3,5.4,5.4,5.4,3-.6,4.1-1.8l1.8,1.7c-1.4,1.7-3.5,2.5-6.1,2.5-4.7,0-8.1-3.3-8.1-7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    className: "cls-3",
    d: "M24.5,32.8v-1.3h-2.8c-1.9,0-2.4.7-2.4,1.5s.8,1.6,2.2,1.6,2.5-.6,2.9-1.8h0ZM27.2,29.7v6.8h-2.6v-1.4c-.7,1-1.9,1.6-3.7,1.6-2.7,0-4.3-1.5-4.3-3.5s1.3-3.5,4.8-3.5h3v-.2c0-1.6-1-2.5-2.9-2.5s-2.7.4-3.5,1.2l-1.1-2c1.2-1,3-1.4,4.9-1.4,3.4,0,5.3,1.6,5.3,4.9h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    className: "cls-3",
    d: "M37.9,24.7v2.6h-.6c-2.1,0-3.4,1.2-3.4,3.6v5.6h-2.7v-11.6h2.6v1.7c.8-1.2,2.2-1.8,4.1-1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    className: "cls-3",
    d: "M50.2,30.7c0-2.2-1.5-3.6-3.4-3.6s-3.5,1.4-3.5,3.6,1.5,3.6,3.5,3.6,3.4-1.4,3.4-3.6ZM53,30.7c0,3.6-2.5,6-5.9,6s-2.9-.5-3.9-1.7v1.5h-2.6v-16.1h2.7v5.9c.9-1,2.2-1.5,3.7-1.5,3.4,0,5.9,2.3,5.9,5.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    className: "cls-3",
    d: "M81.9,29.8v6.7h-2.7v-6.3c0-2.1-1-3.1-2.8-3.1s-3.2,1.2-3.2,3.5v5.9h-2.7v-11.6h2.6v1.5c.9-1.1,2.3-1.6,4-1.6,2.8,0,4.9,1.6,4.9,5.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    className: "cls-3",
    d: "M61.1,24.8c-.5,0-1,0-1.5.2.6.4,1,1.1,1,1.9v.3h.5c2,0,3.5,1.4,3.5,3.6s-1.5,3.6-3.5,3.6-3.4-1.4-3.4-3.6,0-1.2.4-1.8c-.9-.2-1.7-1-1.9-2-.8,1-1.2,2.3-1.2,3.7,0,3.5,2.6,6,6.2,6s6.2-2.5,6.2-6-2.6-5.9-6.2-5.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    className: "cls-1",
    d: "M60,26.7c0,.8-.7,1.5-1.5,1.5s-1.5-.7-1.5-1.5.7-1.6,1.6-1.5c.8,0,1.5.8,1.5,1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    className: "cls-2",
    d: "M58.9,29.6v2.3s0,.2,0,.2l2,1.1h.2l2-1.1s0,0,0-.2v-2.3s0-.2,0-.2l-2-1.1h-.2l-2,1.1s0,0,0,.2Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleLogo);
export default __webpack_public_path__ + "static/media/TitleLogo.cf0906c0faa00c21a8a2af52c8f63275.svg";
export { ForwardRef as ReactComponent };